import { defaultViewPortPadding } from '@app/services/export/ppt/variables/constants';
import { gridColWidth } from '@app/services/export/ppt/utils/gridUtils';
import IOfferCSlideData from '@app/types/data/slides/IOfferCSlideData';
import PowerPointPresentation from '@app/services/export/ppt/PowerPointPresentation';
import { ConnectionNavigation } from '@app/services/export/ppt/classes/ConnectionNavigation';
import { getChunkedListForAvailableSpace } from '@app/services/export/ppt/utils/listUtils';
import IConnectionNavigationItem from '@app/types/data/base/IConnectionNavigationItem';
import AbstractOfferSlideProcessor, {
	IPptOfferSlideOptions
} from '@app/services/export/ppt/slides/AbstractOfferSlideProcessor';

export default class PowerPointOfferCSlideProcessor extends AbstractOfferSlideProcessor<IOfferCSlideData> {
	public constructor(slideData: IOfferCSlideData, presentation: PowerPointPresentation) {
		const options: Partial<IPptOfferSlideOptions> = {
			imageWidth: defaultViewPortPadding.horizontal + gridColWidth(6)
		};

		super(slideData, presentation, options);
	}

	public async processSlideData(): Promise<void> {
		if (this.slideData.image) {
			await this.adjustImageDimensions(this.slideData.image);
		}

		if (this.slideData.copy) {
			this.createTextSlide();
		}
		this.createOverviewTables();
	}

	private createTextSlide(): void {
		this.updateSlideData({ visibleSvgGroup: 'default' });
		this.createOfferSlideBase();
	}

	private createOverviewTables(): void {
		const hasCopy = this.slideData.copy;

		this.updateSlideData({ copy: '', visibleSvgGroup: 'default' });

		const chunks = getChunkedListForAvailableSpace(
			<IConnectionNavigationItem[]>this.slideData.connectionList,
			this.getAvailableSpaceRectangle().h,
			{
				rowHeight: ConnectionNavigation.itemHeight + ConnectionNavigation.itemGap
			}
		);

		chunks.forEach((list, chunkIndex) => {
			const chunksBefore = chunks.slice(0, chunkIndex);
			const sumOfItemsBefore = chunksBefore.reduce((sum, chunk) => sum + chunk.length, 0);

			list.forEach((item, listIndex) => {
				this.updateSlideData({ visibleSvgGroup: item.svgGroupId });
				const { x, y, w } = this.getAvailableSpaceRectangle();
				const offerSlideBase = this.createOfferSlideBase();
				const current = listIndex + 1;
				const slideBaseNumber = this.presentation.getSlideNumberById(this.slideData.id);
				const navigationStartOffset = slideBaseNumber + sumOfItemsBefore + (hasCopy ? 1 : 0);

				const connectionNavigation = new ConnectionNavigation(
					offerSlideBase,
					{ current, list, navigationStartOffset },
					{ x, y, w }
				);

				connectionNavigation.create();
			});
		});
	}

	protected getSlideCount(): number {
		let count = this.slideData.connectionList.length;
		if (this.slideData.copy) count++;
		return count;
	}
}
